module.exports = __webpack_public_path__ + "static/media/homeleftMobileGreen.f9b4144b.png";